module.exports = __webpack_public_path__ + "static/media/linesXC.75a47088.svg";